export const GET_USER_INFO_SUCCESS = 'GET_USER_INFO_SUCCESS';
export const CLEAR_USER_INFO = 'CLEAR_USER_INFO';
